import type { VideoReference } from '@/api/types';

type Shape = Pick<VideoReference, 'media' | 'orientation'>;

/** Вертикаль не уже 4:5, длинные форматы от 2.1 идут как 21:9. */
const VERTICAL_LIMIT = 0.8;
const ULTRA_WIDE_FROM = 2.1;

/**
 * Пропорции карточки в раскладке Natural (README «Grid»): реальные пропорции
 * файла, вертикаль не уже 4:5, горизонталь 16:9, длинные форматы 21:9 — не ниже.
 * Без размеров файла — по ориентации из разметки.
 */
function resolve(video: Shape): { ratio: number; css: string } {
  const width = video.media?.width ?? null;
  const height = video.media?.height ?? null;
  if (width && height) {
    const ratio = width / height;
    if (ratio < 1) {
      const limited = Math.max(ratio, VERTICAL_LIMIT);
      return { ratio: limited, css: String(limited) };
    }
    if (ratio >= ULTRA_WIDE_FROM) return { ratio: 21 / 9, css: '21 / 9' };
    return { ratio: 16 / 9, css: '16 / 9' };
  }
  return video.orientation === 'vertical'
    ? { ratio: 4 / 5, css: '4 / 5' }
    : { ratio: 16 / 9, css: '16 / 9' };
}

/** Значение для CSS-свойства `aspect-ratio` карточки. */
export function cardAspect(video: Shape): string {
  return resolve(video).css;
}

/** Та же пропорция числом (ширина / высота) — для расчёта колонок Natural. */
export function cardAspectRatio(video: Shape): number {
  return resolve(video).ratio;
}
